
import { AccessesToModelsDto, CreateAccessesToModels } from "../Models/AccessModels";
import { User } from "../Models/Models";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class AccessProvider {
    public dataProvider: AccessProvider | undefined;

    public init() {
        if (!this.dataProvider) {
            this.dataProvider = new AccessProvider();
        }
    }

    public update(data: CreateAccessesToModels): Promise<RespondClient<unknown>> {
        return getInstance().post(`${getApiHost()}/api/access`, data);
    }

    public get(data: string): Promise<RespondClient<AccessesToModelsDto[]>> {
        return getInstance().get(`${getApiHost()}/api/access/${data}`);
    }

    public delete(data: string): Promise<RespondClient<unknown>> {
        return getInstance().delete(`${getApiHost()}/api/access/${data}`);
    }

    public search(data: string, id: string): Promise<RespondClient<User>> {
        return getInstance().get(`${getApiHost()}/api/access/search/${id}/${data}`);
    }
}

export const AccessProviderInstance = new AccessProvider();
